module.exports = __webpack_public_path__ + "img/voice.15adcf82.svg";